<template>
  <div class="main" id="main">
    <el-form :inline="true" :model="params" ref="params">
      <el-form-item>
        <el-date-picker
          v-model="params.target"
          type="date"
          placeholder="目标日期"
          value-format="yyyy-MM-dd"
          align="center"
          @change="searchBtn"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-input
          placeholder="请输入班级号"
          clearable
          v-model.trim="params.classId"
          @clear="searchBtn"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="searchBtn"
          >查询</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          v-permission="['liveClassSet:add']"
          @click="addBtn"
          >添加</el-button
        >
      </el-form-item>
    </el-form>
    <el-s-table :columns="columns" :data="list" border fix-window>
      <template v-slot:default="{ row }">
        <el-button
          type="text"
          v-permission="['liveClassSet:edit']"
          @click="editBtn(row)"
          >编辑</el-button
        >
        <el-button
          type="text"
          v-permission="['liveClassSet:del']"
          @click="delBtn(row)"
          >删除</el-button
        >
      </template>
    </el-s-table>
    <div class="pagebox">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        background
      >
      </el-pagination>
    </div>
    <LiveClassSetForm ref="LiveClassSetForm" @confirm="handleConfirm" />
  </div>
</template>

<script>
import { listLiveClass, deleteLiveClass } from "@/api/settings/liveClassSet.js";
import LiveClassSetForm from "./components/LiveClassSetForm.vue";
import { parseTime } from "@/utils/index";
export default {
  name: "LiveClassSet",
  components: {
    LiveClassSetForm,
  },
  data() {
    return {
      columns: [
        {
          prop: "id",
          label: "id",
        },
        {
          prop: "classId",
          label: "班级号",
        },
        {
          prop: "target",
          label: "日期",
          formatter: (row) => parseTime(row.target, "{y}-{m}-{d}"),
        },
        {
          prop: "link",
          label: "直播链接",
        },
        {
          prop: "course",
          label: "课程",
          formatter: (row) =>
            row.course ? row.course.groupName + row.course.day : "",
        },
        {
          prop: "default",
          label: "操作",
        },
      ],
      params: {
        target: parseTime(new Date(), "{y}-{m}-{d}"),
      },
      page: 1,
      pageSize: 10,
      total: 0,
      list: [],
    };
  },

  created() {},

  mounted() {
    this.initData();
  },

  activated() {
    this.initData();
  },

  deactivated() {
    this.list = [];
  },

  methods: {
    initData() {
      // 页面初始打开mounted，activated都会走，防止二次调用
      if (this.initResolve) return;
      this.initResolve = Promise.all([this.getList()]).then((res) => {
        this.initResolve = null;
      });
    },
    searchBtn() {
      this.page = 1;
      this.getList();
    },
    // 获取列表
    async getList() {
      let params = {
        pageNumber: this.page,
        pageSize: this.pageSize,
        ...this.params,
      };
      if (!params.classId) delete params.classId;
      console.log(params);
      this.list = [];
      this.total = 0;
      const { code, data: list, message } = await listLiveClass(params);
      if (code == 200) {
        this.list = list;
        // this.total = total;
        return;
      }
      this.$message.error(message);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    addBtn() {
      this.$refs.LiveClassSetForm.show();
    },
    editBtn(row) {
      this.$refs.LiveClassSetForm.show(row);
    },
    delBtn(row) {
      this.$confirm("确定删除该条数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const { code, message } = await deleteLiveClass({ id: row.id });
        if (code == 200) {
          this.$message.success("删除成功");
          this.getList();
          return;
        }
      });
    },
    handleConfirm({ isUpdate }) {
      if (isUpdate) {
        this.getList();
      } else {
        this.searchBtn();
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
